<template>
    <div class="pcPage">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
</template>

<script>
export default {
    name: 'pcpage',
    data: function () {
        return {
            
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.pcPage {
    width: 100%;
    height: 100%;
    min-width: 1200px;
    position: relative;
    font-family: 'Microsoft YaHei';
}
</style>
